import { styled } from "@mui/material/styles";

export const SwaggerLink = styled("a")(({ theme }) => ({
  color: theme.custom.colors.mediMagenta,
  marginRight: 10,
  "&:hover, &:focus, &:active, &:visited": {
    textDecoration: "none",
    color: theme.custom.colors.mediMagenta,
  },
}));
